module.exports = __webpack_public_path__ + "img/2020_11_05_mouth_head.af84fc08.jpg";